<template>
  <div>
    <div class="pnl_box">
      <div class="pnl_label">
        {{ label }}
      </div>
      <div class="pnl_value" :class="color_class">
        {{ str_val }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HighlightsCard",
  props: {
    label: {
      default: "label",
      type: String,
    },
    value: {
      default: 0,
      type: Number,
    },
    color: {
      default: false,
      type: Boolean,
    },
    string_value: {
      default: "",
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    color_class() {
      if (this.color) {
        if (this.value >= 0) {
          return "profit_color";
        } else {
          return "loss_color";
        }
      } else {
        return "black_color";
      }
    },
    str_val() {
      if (this.color) {
        return this.string_value;
      } else {
        return this.value;
      }
    },
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.pnl_box {
  padding: 6px 12px;
  align-items: center;
  gap: 30px;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.pnl_label {
  color: #757575;

  font-family: Avenir;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.pnl_value {
  font-family: Avenir;
  font-size: 13px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.profit_color {
  color: green;
}
.loss_color {
  color: red;
}
.black_color {
  color: #283037;
}
</style>
